import React from 'react';
import { Spinner } from '@invent/wl-ui-kit';
import { PreloadBox } from './styled';

export function Preload(): JSX.Element {
  return (
    <PreloadBox>
      <Spinner />
      Loading...
    </PreloadBox>
  );
}
